import { Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface PointData {
  point_id: any;
}

export interface EventElement {
  point_id: string;
  srNo: string;
  point: string;
  created_by: string;
  action: any;
}

@Component({
  selector: 'app-scanning-point',
  templateUrl: './scanning-point.component.html',
  styleUrls: ['./scanning-point.component.scss'],
  standalone: false
})

export class ScanningPointComponent {
  displayedColumns: string[] = [
    'srNo',
    'point',
    'created_by',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  event_result: any;
  point_id: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) { }

  ngAfterViewInit() {
    this.Get_Scanning();
    this.dataSource.paginator = this.paginator;
  }

  AddScanningPoint() {
    const dialogRef = this.dialog.open(add_edit_scanning, {
      data: {
        point_id: this.point_id
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Scanning();
    });
  }

  EditScanningPoint(point_id: any) {
    const dialogRef = this.dialog.open(add_edit_scanning, {
      data: {
        point_id: point_id
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Scanning();
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Scanning() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_scanning_point().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data;
        this.ELEMENT_DATA = this.event_result.map((item: { point_id: any; point: any; created_by: any }, index: number) => ({
          srNo: index + 1,
          point_id: item.point_id,
          point: item.point,
          created_by: item.created_by,
          action: item.point_id
        })
        );
        this.spinner.hide();
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  DeletePoint(point_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Event?');
    if (buttonClicked === true) {
      this.service.delete_scanning_point(point_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.point_id !== point_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Point Deleted Succesfully");
        });
    }
  }
}



@Component({
  selector: 'add_edit_scanning',
  templateUrl: './add_edit_scanning.html',
  styleUrls: ['./scanning-point.component.scss'],
  standalone: false
})
export class add_edit_scanning {

  ScanningForm: FormGroup;
  point_id: any
  result: any;
  hide = true;
  point: any
  private destoryRef = inject(DestroyRef);
  point_data: any;
  event_id: any;
  whatsapp_checkin: any;
  whatsapp_checkout: any;
  whatsapp_checkin_msg: any;
  whatsapp_checkout_msg: any;
  scan_method: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_scanning>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: PointData
  ) {
    this.point_id = data['point_id'];
    this.ScanningForm = this.member.group({
      point_id: this.point_id,
      point: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      whatsapp_checkin: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      whatsapp_checkin_msg: new FormControl(''),
      whatsapp_checkout: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      whatsapp_checkout_msg: new FormControl(''),
      scan_method: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.Get_Scanning_By_Id(this.point_id)
  }

  Get_Scanning_By_Id(point_id: any) {
    this.service.get_scanning_point_by_id(point_id).subscribe(
      (data: any) => {
        this.point_data = data.data;
        this.point_id = this.point_data[0].point_id;
        this.point = this.point_data[0].point;
        this.whatsapp_checkin = this.point_data[0].whatsapp_checkin;
        this.whatsapp_checkin_msg = this.point_data[0].whatsapp_checkin_msg;
        this.whatsapp_checkout = this.point_data[0].whatsapp_checkout;
        this.whatsapp_checkout_msg = this.point_data[0].whatsapp_checkout_msg;
        this.scan_method = this.point_data[0].scan_method;
      });
  }

  onFormSubmit() {
    const formData = this.ScanningForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.ScanningForm.valid && hasNonEmptyField) {

      if (this.point_id) {
        this.service.edit_scanning_point(this.ScanningForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Point Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_scanning_point(this.ScanningForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Point Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}